export default "__VITE_ASSET__DEqI8eOW__"